<script>
import axios from "axios";

export default {
  name: "ModalSeguridad",
  data() {
    return {
      //
    };
  },
  props: {
    url_documento: String,
    nombre_documento: String
  },
  methods: {
    download(url) {
      axios
        .get(url, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = this.nombre_documento;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
  },
};
</script>

<template>

  <div 
    class="modal fade" 
    id="modal-archivo"
    tabindex="-1"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header d-flex justify-content-end border-0 pb-0">
          <a 
            class="h3 mb-0 link-secondary" 
            href="javascript:"
            data-bs-dismiss="modal"
          >
          <font-awesome-icon icon="fa-solid fa-xmark"></font-awesome-icon>
          </a>
        </div>
        <div class="modal-body">

          <img
            v-if="url_documento.includes('.jpg')"
            :src="url_documento"
            class="img-fluid"
            :alt="nombre_documento"
          />

          <iframe
            v-else
            :src="url_documento"
            frameborder="0"
            width="100%"
            height="500px"
          ></iframe>
          
        </div>
        <div class="modal-footer">
          <button 
            type="button" 
            class="btn btn-custom btn-custom-line-gray mw-150" 
            data-bs-dismiss="modal">
            <font-awesome-icon icon="fa-solid fa-angle-left" class="pe-2"></font-awesome-icon>
            Volver
          </button>
          <a 
            @click="download(url_documento)"
            class="btn btn-custom btn-custom-main mw-150">
            <font-awesome-icon icon="fa-solid fa-download" class="pe-2"></font-awesome-icon>
            Descargar
        </a>
        </div>
      </div>
    </div>
  </div>

</template>